// React related imports
import { useContext } from 'react';

// Context and Hooks
import { GeneralizationContext } from '../../contexts/GeneralizationContext';

// Types
import { SourcesActionsProps } from './types';

// Others
import { Button, Dropdown } from '@GxT-Team/gxt-components';
import { SourceVersion } from '../../hooks/types';
import { getDropdownOptions } from '../../helpers/utils';

// Module-level constants — same object references on every render, so Dropdown's
// useEffect([initialValue]) fires exactly once per mount and immediately bails out
// (lazy initializer already set state to the same ref).
const VERSION_OPTION: Record<string, SourceVersion> = { original: 'Original', parsed: 'Parsed' };
const DROPDOWN_OPTIONS = getDropdownOptions(Object.values(VERSION_OPTION));
const INITIAL_VALUE_PARSED: { value: SourceVersion } = { value: VERSION_OPTION.parsed };
const INITIAL_VALUE_ORIGINAL: { value: SourceVersion } = { value: VERSION_OPTION.original };

const SourcesActions = ({
  navigateAddSource,
  sourceFilesDropdown,
  lockedFileSwitch,
  handleSourceToggle,
  displayLockFileButton,
}: SourcesActionsProps) => {
  const { isOriginalAvailable, isParsed } = useContext(GeneralizationContext);

  return (
    <>
      <h2 className="text-primary-300 mb-2">Sources</h2>
      <div className="flex items-center space-x-3">
        {sourceFilesDropdown}
        {displayLockFileButton && lockedFileSwitch}
        {/* key forces remount when isParsed changes, ensuring effect fires once per mount */}
        <Dropdown
          key={isParsed ? 'parsed' : 'original'}
          customStyles={{
            placeholder: { color: 'var(--neutral-400)' },
            itemsWrapper: { zIndex: 100, width: '100%' },
          }}
          disabled={!isOriginalAvailable}
          dropdownIcon
          initialValue={isParsed ? INITIAL_VALUE_PARSED : INITIAL_VALUE_ORIGINAL}
          options={DROPDOWN_OPTIONS}
          onSelect={handleSourceToggle}
          position="bottom"
          type="select"
        />
        <Button variant="secondary" data-testid="add-source-button" onClick={navigateAddSource}>
          Add Sources
        </Button>
      </div>
    </>
  );
};

export default SourcesActions;
